import React from 'react';
import Type from 'prop-types';
import { TextField, Autocomplete } from '@mui/material';
import { fieldToTextField } from 'formik-mui';
import { t } from 'utils/i18n';

const SimpleAutocomplete = ({ displayError = true, TextFieldProps, onChange, ...props }) => {
  const { error, helperText, ...field } = fieldToTextField(props);
  const { name } = field;

  const handleChange = (event, value, reason, details) => {
    props.form.setFieldValue(name, value);
    if (onChange) {
      onChange(event, value, reason, details);
    }
  };

  return (
    <Autocomplete
      {...field}
      loadingText={t('loading')}
      noOptionsText={t('notFound')}
      isOptionEqualToValue={(option, value) => option.id === value?.id}
      onChange={handleChange}
      onBlur={() => props.form.setFieldTouched(name, true)}
      {...props}
      renderInput={(params) => (
        <TextField
          {...params}
          {...TextFieldProps}
          name={name}
          helperText={displayError ? helperText : undefined}
          error={displayError && error}
        />
      )}
    />
  );
};

SimpleAutocomplete.propTypes = {
  displayError: Type.bool,
  form: Type.shape({
    errors: Type.object,
    setFieldTouched: Type.func,
    setFieldValue: Type.func,
  }).isRequired,
  TextFieldProps: Type.shape({
    label: Type.string,
    required: Type.bool,
    fullWidth: Type.bool,
    margin: Type.oneOf(['none', 'dense', 'normal']),
  }),
  options: Type.array.isRequired,
  getOptionLabel: Type.func,
};

export default SimpleAutocomplete;
